import { isNil } from 'lodash';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { enableChangeColor } from '../../js/colorHandling';
import { toolbarActive } from '../../js/webGL';
import { setShow } from '../../redux-tool/slice/controlSlice';
import { setActiveTabBarId } from '../../redux-tool/slice/uiSlice';

export function useTabBarFuncs(swiperRef) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isNil(swiperRef) || isNil(swiperRef.current)) return;
    window.gotoTab = (index) => {
      swiperRef.current?.slideToLoop(index, 500);
      handleActiveIndexChanged(index);
    };
  }, [swiperRef]);

  const handleClick = (item, index) => {
    console.log('SwiperRef', swiperRef);
    swiperRef?.current?.slideToLoop(index, 500);
    handleActiveIndexChanged(item.fcID);
  };

  const handleActiveIndexChanged = (idx) => {
    if (idx === 0) {
      toolbarActive.value = 'logo';
    } else if (idx === 1) {
      toolbarActive.value = 'text';
    } else if (idx === 2) {
      toolbarActive.value = 'style';
    } else if (idx === 3) {
      toolbarActive.value = 'color';
    } else if (idx === 4) {
      toolbarActive.value = 'pattern';
    }
    enableChangeColor(idx === 3);

    dispatch(setShow(false));
    //dispatch(setIsShowMenu(true));
    console.log('setActiveTabBarId', idx);
    dispatch(setActiveTabBarId(idx));
  };

  return { handleClick, handleActiveIndexChanged };
}
